const electron = require("electron");
module.exports = {
  development: {
    client: "sqlite3",
    connection: {
      filename: "./dist/database/" + process.env.DATABASE,
    },
    useNullAsDefault: true,
    // debug: true,
  },
  production: {
    client: "sqlite3",
    connection: {
      filename: electron.remote.app.getPath("userData") + "/" + process.env.DATABASE,
    },
    useNullAsDefault: true,
  },
};
